<template>
    <ul class="program-list">
        <li v-for="(item, index) in items" :key="index">
            <v-row justify="center" align="center" no-gutters>
                <v-col cols="12" lg="6" :class="{ 'order-lg-2': (index + 1) % 2 === 0 }">
                    <div class="d-flex justify-center">
                        <v-card color="primary" max-width="560" class="program-list__card">
                            <v-img :src="item.image" alt="" />
                        </v-card>
                    </div>
                </v-col>
                <v-col cols="auto" lg="6">
                    <div class="pa-20 pa-lg-40">
                        <v-row>
                            <v-col cols="12">
                                <h4 class="tit tit--sm primary--text">
                                    {{ item.title }}
                                </h4>
                            </v-col>
                            <v-col cols="12">
                                <v-row v-for="text in item.texts" :key="text" class="row--sm page-text page-text--lg">
                                    <v-col cols="auto">·</v-col>
                                    <v-col>
                                        <p v-html="text" />
                                    </v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                    </div>
                </v-col>
            </v-row>
        </li>
    </ul>
</template>

<script>
export default {
    props: {
        items: String,
    },
};
</script>

<style lang="scss" scoped>
.program-list {
    > li {
        &:not(:last-child) {
            padding-bottom: 60px;
        }
    }
    &__card {
        border-radius: 16px;
        margin-top: 20px;
        margin-left: 20px;
        .v-image {
            border-radius: inherit;
            transform: translate(-20px, -20px);
        }
    }
}
@media (min-width: 768px) {
    .program-list {
        > li {
            &:not(:last-child) {
                padding-bottom: 100px;
            }
        }
        &__card {
            margin-top: 40px;
            margin-left: 40px;
            .v-image {
                transform: translate(-40px, -40px);
            }
        }
    }
}
</style>